import ConfirmDeleteModal from "@/components/shared/ConfirmDeleteModal/ConfirmDeleteModal";
import { ToastSuccess } from "@/components/shared/toast/Toast";
import {
  CButton,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
  CSmartTable,
} from "@coreui/react-pro";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import { createIndexes, formatMoney } from "../../../shared/utils/ultils";
import { AppDispatch } from "../../../store";
import CustomTableFooter from "../../shared/CustomTableFooter/CustomTableFooter";
import FilterIcon from "../../shared/icons/FilterIcon";
import SearchIcon from "../../shared/icons/SearchIcon";
import { getEntities, removeEntity, updateEntity } from "./orderManagement.api";
import OrderUpdate from "./OrderUpdate";
import { IOrder } from "@/shared/model/order.model";
import {
  addItem,
  fetching,
  orderSelectors,
  resetEntity,
  setFilterState,
  updateItem,
} from "./orderManagement.reducer";
import {
  mapOrderResponseStatus,
  mapOrderResponseStatusToColor,
  OrderResponseStatus,
} from "@/shared/enumeration/OrderResponseStatus";
import dayjs from "dayjs";
import { socket } from "@/shared/config/socket";

const columns = [
  {
    key: "id",
    label: "ID",
    sorter: false,
  },
  {
    key: "userId",
    label: "ID - Thành viên",
    sorter: false,
  },
  {
    key: "code",
    label: "Mã đơn",
    sorter: false,
  },
  {
    key: "money",
    label: "Số tiền",
    sorter: false,
  },
  {
    key: "commission",
    label: "Hoa hồng",
    sorter: false,
  },
  {
    key: "rate",
    label: "Tỷ lệ hoa hồng",
    sorter: false,
  },
  {
    key: "currentMoney",
    label: "Số dư",
    sorter: false,
  },
  {
    key: "productId",
    label: "Sản phẩm",
    sorter: false,
  },
  {
    key: "createdDate",
    label: "Thời gian",
    sorter: false,
  },
  {
    key: "status",
    label: "Tình trạng",
    sorter: false,
  },
  {
    key: "actions",
    label: "Thao tác",
    sorter: false,
    _props: { className: "text-center", width: "200px" },
  },
];

interface IIndexOrder extends IOrder {
  index: number;
}

const OrderManagement = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { initialState } = useSelector(
    (state: RootState) => state.ordersReducer
  );
  const {
    filterState,
    totalItems,
    totalPages,
    loading,
    updateEntitySuccess,
    deleteEntitySuccess,
  } = initialState;
  const [createOrder, setCreateOrder] = useState<boolean>(false);
  const [updateOrder, setUpdateOrder] = useState<IOrder | null>(null);
  const handleCreateOrder = () => {
    setCreateOrder(true);
  };

  const handleUpdateOrder = (level: IOrder) => () => {
    setUpdateOrder(level);
  };

  const handleCancelUpdateOrder = (update?: boolean) => {
    setUpdateOrder(null);
  };

  const handlePaginationChange = (page: number) => {
    if (page !== 0) {
      window.scrollTo(0, 0);
      dispatch(setFilterState({ ...filterState, page: page, keyword }));
    }
  };

  const orders = useSelector(orderSelectors.selectAll);
  const indexedOrder = createIndexes(orders, filterState);

  useEffect(() => {
    if (updateEntitySuccess && !createOrder && !updateOrder) {
      ToastSuccess("Cập nhật thành công");
      dispatch(resetEntity());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateEntitySuccess]);

  useEffect(() => {
    if (!deleteEntitySuccess) {
      dispatch(fetching());
      dispatch(getEntities(filterState));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(filterState), deleteEntitySuccess]);

  useEffect(() => {
    if (deleteEntitySuccess) {
      ToastSuccess("Xoá đơn hàng thành công");
      dispatch(resetEntity());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteEntitySuccess]);

  const [chosenDelete, setChosenDelete] = useState<IOrder | null>(null);
  const [chosenDongBang, setChosenDongBang] = useState<IOrder | null>(null);
  const [chosenTanBang, setChosenTanBang] = useState<IOrder | null>(null);

  const handleDelete = () => {
    if (chosenDelete) {
      dispatch(removeEntity(chosenDelete.id.toString()));
      setChosenDelete(null);
    }
  };

  const handleDongBang = () => {
    if (chosenDongBang) {
      const body: IOrder = {
        ...chosenDongBang,
        status: OrderResponseStatus.INACTIVE,
      };
      dispatch(updateEntity(body));
      setChosenDongBang(null);
    }
  };

  const handleTanBang = () => {
    if (chosenTanBang) {
      const body: IOrder = {
        ...chosenTanBang,
        status: OrderResponseStatus.NEW,
      };
      dispatch(updateEntity(body));
      setChosenTanBang(null);
    }
  };

  const handleCancelDelete = () => {
    setChosenDelete(null);
  };

  const handleCancelDongBang = () => {
    setChosenDongBang(null);
  };

  const handleCancelTanBang = () => {
    setChosenTanBang(null);
  };

  const [keyword, setKeyword] = useState<string>("");

  const onSearch = () => {
    dispatch(getEntities({ ...filterState, keyword }));
  };

  useEffect(() => {
    socket.on("send_new_order", (data) => {
      dispatch(addItem(data));
    });

    socket.on("send_update_order", (data) => {
      console.log(data, 'datadatadata')
      dispatch(updateItem(data));
    });

    return () => {
      socket.off("send_new_order");
      socket.off("send_update_order");
    };
  }, []);

  return (
    <>
      <div className="tab-outlet-content">
        <div className="table-context">
          <div className="d-flex">
            <CFormInput
              style={{ minWidth: 350 }}
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="ID, Tên đăng nhập, Số điện thoại, Mã đơn"
            />
            <CButton
              style={{ height: 42, whiteSpace: "nowrap" }}
              className="ms-2 btn-custom btn-sm text-white"
              onClick={onSearch}
            >
              Tìm kiếm
            </CButton>
          </div>
          <div>
            {/* <CButton className="btn-custom primary-500 btn-sm" onClick={handleCreateOrder}>
              <PlusIcon /> Tạo cấp độ mới
            </CButton> */}
          </div>
          <div className="d-none">
            <CInputGroup className="search-group me-2">
              <CInputGroupText id="search-addon">
                <SearchIcon />
              </CInputGroupText>
              <CFormInput
                placeholder="Tìm kiếm theo tên"
                aria-label="Ordername"
                aria-describedby="basic-addon1"
              />
            </CInputGroup>
            <CButton className="btn-custom gray-700 btn-sm">
              <FilterIcon /> Lọc
            </CButton>
          </div>
        </div>

        <div className="table-content">
          <CSmartTable
            header
            loading={loading}
            columns={columns}
            items={indexedOrder}
            clickableRows
            noItemsLabel="Không có bản ghi"
            itemsPerPage={filterState.limit}
            scopedColumns={{
              currentMoney: ({ index, ...value }: IIndexOrder) => (
                <td>{formatMoney(value?.currentMoney ?? 0)}</td>
              ),
              createdDate: ({ index, ...value }: IIndexOrder) => (
                <td>
                  {dayjs(value.createdDate).format("DD/MM/YYYY HH:mm:ss")}
                </td>
              ),
              productId: ({ index, ...value }: IIndexOrder) => (
                <td>
                  <div className="truncate-text-200">{value.product?.name}</div>
                </td>
              ),
              userId: ({ index, ...value }: IIndexOrder) => (
                <td>
                  {value.user?.id} - {value.user?.username}
                </td>
              ),
              money: ({ index, ...value }: IIndexOrder) => (
                <td>{formatMoney(value.money ?? 0)}</td>
              ),
              commission: ({ index, ...value }: IIndexOrder) => (
                <td>{formatMoney(value.commission ?? 0)}</td>
              ),
              rate: ({ index, ...value }: IIndexOrder) => (
                <td>{value.rate}%</td>
              ),
              status: ({ index, ...value }: IIndexOrder) => (
                <td>
                  <div className="d-flex align-items-center flex-nowrap">
                    <span
                      className={`badge bg-${
                        mapOrderResponseStatusToColor[value.status]
                      }`}
                    >
                      {mapOrderResponseStatus[value.status]}
                    </span>
                  </div>
                </td>
              ),
              actions: ({ index, ...value }: IIndexOrder) => (
                <td>
                  <CInputGroup className="custom-input-group-action justify-content-center">
                    {/* <CInputGroupText onClick={handleUpdateOrder(value)}>
                      <Edit02Icon />
                    </CInputGroupText> */}

                    {value.status == OrderResponseStatus.NEW && (
                      <CInputGroupText
                        onClick={() => setChosenDongBang(value)}
                        style={{ fontSize: 12 }}
                      >
                        Đóng băng
                      </CInputGroupText>
                    )}

                    {value.status == OrderResponseStatus.INACTIVE && (
                      <CInputGroupText
                        onClick={() => setChosenTanBang(value)}
                        style={{ fontSize: 12 }}
                      >
                        Tan băng
                      </CInputGroupText>
                    )}

                    <CInputGroupText
                      onClick={() => setChosenDelete(value)}
                      style={{ fontSize: 12 }}
                    >
                      Xoá
                    </CInputGroupText>
                  </CInputGroup>
                </td>
              ),
            }}
            tableProps={{
              hover: true,
              align: "middle",
              responsive: "lg",
              className: "custom-table",
            }}
            tableHeadProps={{
              className: "table-head",
            }}
            tableBodyProps={{
              className: "table-body",
            }}
          />
        </div>

        {createOrder ? (
          <OrderUpdate visible={createOrder} setVisible={setCreateOrder} />
        ) : (
          ""
        )}
        {updateOrder ? (
          <OrderUpdate
            visible={Boolean(updateOrder)}
            levelObj={updateOrder}
            setVisible={handleCancelUpdateOrder}
          />
        ) : (
          ""
        )}
        <CRow>
          <CustomTableFooter
            totalItems={totalItems}
            hideSideChosen
            totalPages={totalPages}
            filterState={filterState}
            setFilterState={(filter) => dispatch(setFilterState(filter))}
            handlePaginationChange={handlePaginationChange}
          />
        </CRow>
      </div>
      {chosenTanBang ? (
        <ConfirmDeleteModal
          visible={Boolean(chosenTanBang)}
          handleOnClose={handleCancelTanBang}
          handleDelete={handleTanBang}
          title="Tan băng đơn hàng"
          content={
            <>
              Xác nhận tan băng đơn hàng{" "}
              <span className="high-light">{chosenTanBang?.code}</span> ?
            </>
          }
        />
      ) : (
        ""
      )}

      {chosenDongBang ? (
        <ConfirmDeleteModal
          visible={Boolean(chosenDongBang)}
          handleOnClose={handleCancelDongBang}
          handleDelete={handleDongBang}
          title="Đóng băng đơn hàng"
          content={
            <>
              Xác nhận đóng băng đơn hàng{" "}
              <span className="high-light">{chosenDongBang?.code}</span> ?
            </>
          }
        />
      ) : (
        ""
      )}

      {chosenDelete ? (
        <ConfirmDeleteModal
          visible={Boolean(chosenDelete)}
          handleOnClose={handleCancelDelete}
          handleDelete={handleDelete}
          title="Xoá đơn hàng khỏi hệ thống"
          content={
            <>
              Xác nhận xoá đơn hàng{" "}
              <span className="high-light">{chosenDelete?.code}</span> khỏi hệ
              thống?
            </>
          }
        />
      ) : (
        ""
      )}
    </>
  );
};

export default OrderManagement;
